import {ACTIONS, type Execution} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import

export class ActionExecution {
    public getDashboardPanelExecutor = (actionId: string): Execution => {
        return {
            actionType: ACTIONS.ACTION_TYPE.panel,
            panel: {
                panelType: ACTIONS.PANEL_TYPE.inline,
                inline: {
                    referenceId: actionId
                }
            }
        }
    }

    public getCustomPanelExecutor = (actionId: string): Execution => {
        return {
            actionType: ACTIONS.ACTION_TYPE.panel,
            panel: {
                panelType: ACTIONS.PANEL_TYPE.panelId,
                panelId: actionId
            }
        }
    }

    private getDesignFields = (): Execution => {
        return {
            actionType: ACTIONS.ACTION_TYPE.forward,
            forward: {
                actionName: ACTIONS.ACTION_NAME.design,
                elementPath: '.self'
            }
        }
    }

    public createFields = (type: string) => {
        switch (type) {
            case 'design':
                return this.getDesignFields()
        }
    }
}
